(function () {
  'use strict';

  /* ============================================================
     fartilo-wiper-lookup.js — tiered quota + YMM fitment lookup
     All limits read from data-* attributes on [data-fdp-lookup-root].
     No hardcoded quota values in this file.
     v2: adds 818-series product card alongside 799 card.
     v3: no-match fallback zone (#fdp-no-match) when both 799+818 miss.
     v4: 818 URL read from data-source-url-818 (versioned via asset_url).
         fits-structure validation; old sizes-only data silently skipped.
     ============================================================ */

  /* ---- localStorage quota helpers ---- */

  function todayKey() {
    var d = new Date();
    return 'fdp_d_' + d.getFullYear() + '_' + (d.getMonth() + 1) + '_' + d.getDate();
  }

  function weekKey() {
    var d = new Date();
    var jan1 = new Date(d.getFullYear(), 0, 1);
    var week = Math.ceil((((d - jan1) / 86400000) + jan1.getDay() + 1) / 7);
    return 'fdp_w_' + d.getFullYear() + '_' + week;
  }

  function getStorageKey(period) {
    return period === 'daily' ? todayKey() : weekKey();
  }

  function getUsed(period) {
    try {
      return parseInt(localStorage.getItem(getStorageKey(period)) || '0', 10);
    } catch (e) {
      return 0;
    }
  }

  function incrementUsed(period) {
    try {
      var k = getStorageKey(period);
      var n = parseInt(localStorage.getItem(k) || '0', 10) + 1;
      localStorage.setItem(k, String(n));
      return n;
    } catch (e) {
      return 1;
    }
  }

  function saveLastResult(brand, model, year, resultHtml) {
    try {
      var record = { brand: brand, model: model, year: year, html: resultHtml, ts: Date.now() };
      var history = [];
      try { history = JSON.parse(localStorage.getItem('fdp_history') || '[]'); } catch (e) { history = []; }
      history.unshift(record);
      if (history.length > 20) history = history.slice(0, 20);
      localStorage.setItem('fdp_history', JSON.stringify(history));
    } catch (e) {}
  }

  /* ---- result renderers (preserved from original) ---- */

  function fmtYear(y) {
    if (!y) return '';
    var yr = Math.floor(y / 100);
    var mo = y % 100;
    return (mo ? mo + '/' : '') + yr;
  }

  function rangeLabel(item) {
    if (item.y0 && item.y1) return fmtYear(item.y0) + ' \u2013 ' + fmtYear(item.y1);
    if (item.y0) return fmtYear(item.y0) + ' \u2013 present';
    return item.yr || '\u2014';
  }

  function buildResultHtml(item, requestedYear) {
    if (!item) {
      return '<p class="fdp-result__empty">No exact match for ' + requestedYear +
        '. Try a different year, or contact us for manual fitment support.</p>';
    }
    var rows = [
      ['Driver side', item.d],
      ['Passenger side', item.p],
      ['Rear wiper', item.rs],
    ].filter(function (r) { return r[1]; });

    var html = '<div class="fdp-result__card">';
    html += '<p class="fdp-result__vehicle">' + item.b + ' \u2014 ' + item.m + '</p>';
    html += '<p class="fdp-result__range">Model years: ' + rangeLabel(item) + '</p>';
    html += '<table class="fdp-result__table">';
    rows.forEach(function (r) {
      html += '<tr><th>' + r[0] + '</th><td>' + r[1] + '</td></tr>';
    });
    if (item.fc) html += '<tr><th>Fartilo code</th><td>' + item.fc + '</td></tr>';
    if (item.rc) html += '<tr><th>Rear code</th><td>' + item.rc + '</td></tr>';
    html += '</table>';
    html += '<p class="fdp-result__note">Please confirm before installation. Contact us if you need help verifying fitment.</p>';
    html += '</div>';
    return html;
  }

  function buildClosestHtml(matches, requestedYear) {
    if (!matches.length) return buildResultHtml(null, requestedYear);
    var html = '<p class="fdp-result__empty">No exact match for ' + requestedYear +
      '. This model is available for these year ranges:</p><ul class="fdp-result__list">';
    matches.forEach(function (m) { html += '<li>' + rangeLabel(m) + '</li>'; });
    html += '</ul>';
    return html;
  }

  /* ---- 818 normalization helpers ---- */

  /**
   * Normalize brand string for 818 matching:
   * Remove bracketed suffixes, take part before "/", uppercase.
   * e.g. "Toyota (USA)" -> "TOYOTA", "VW/Audi" -> "VW"
   */
  function normBrand(raw) {
    if (!raw) return '';
    var s = raw.replace(/\s*[\(\[（【][^\)\]）】]*[\)\]）】]/g, '');
    var idx = s.indexOf('/');
    if (idx > 0) s = s.substring(0, idx);
    return s.trim().toUpperCase();
  }

  /**
   * Normalize model string for 818 matching:
   * Remove .0 suffix, remove [] and () content, lowercase, collapse spaces.
   * e.g. "Camry 2.0" -> "camry", "Corolla (GLX)" -> "corolla", "Golf [TDI]" -> "golf"
   */
  function normModel(raw) {
    if (!raw) return '';
    var s = raw.replace(/\.0$/g, '');
    s = s.replace(/\s*[\[\(（【][^\]\)）】]*[\]\)）】]/g, '');
    s = s.toLowerCase().replace(/\s+/g, ' ').trim();
    return s;
  }

  /**
   * Filter 818 fits array by year (strict: y0 <= year <= y1).
   * Returns array of matching fit objects; empty if none match.
   * @param {Array} fits - array of {s, y0, y1, y_disp}
   * @param {number} year - integer year e.g. 2005
   */
  function filter818ByYear(fits, year) {
    if (!fits || !fits.length) return [];
    return fits.filter(function (fit) {
      var lo = fit.y0 || 0;
      var hi = fit.y1 || 9999;
      return year >= lo && year <= hi;
    });
  }

  /**
   * Build product cards HTML for 799 and 818 series.
   * @param {object|null} item799 - matched 799 fitment record (may have .fc)
   * @param {object|null} item818 - matched 818 fitment record (fits structure: has .fits array)
   * @param {number} requestedYear - integer year for strict 818 year filtering
   * @returns {{ html: string, has799Card: boolean, has818Card: boolean }}
   */
  function buildProductCardsResult(item799, item818, requestedYear) {
    var cards = [];
    var has799Card = false;
    var has818Card = false;

    if (item799 && item799.fc) {
      has799Card = true;
      cards.push(
        '<a class="fdp-product-card fdp-product-card--799" href="/products/fartilo-799-wiper-blade">' +
          '<div class="fdp-product-card__body">' +
            '<span class="fdp-product-card__badge">799 Series</span>' +
            '<p class="fdp-product-card__title">Fartilo 799 Beam Wiper Blade</p>' +
            '<p class="fdp-product-card__sub">Fitment: ' + item799.fc + '</p>' +
          '</div>' +
          '<span class="fdp-product-card__cta">View &amp; Order &rarr;</span>' +
        '</a>'
      );
    }

    /* 818 card: requires fits structure with y0/y1 for strict year filtering.
       Old sizes-only data (no .fits) is rejected defensively — do not render. */
    if (item818) {
      if (!Array.isArray(item818.fits)) {
        /* Data version mismatch: old structure without fits — skip 818 card */
        console.warn('[fartilo-wiper-lookup] 818 data missing fits array — data version mismatch. Skipping 818 card. Check data-source-url-818 attribute.');
      } else {
        var matchedFits = filter818ByYear(item818.fits, requestedYear);
        if (matchedFits.length > 0) {
          has818Card = true;
          /* Deduplicate sizes from matched fits */
          var sizesSet = {};
          matchedFits.forEach(function (fit) { sizesSet[fit.s] = true; });
          var sizesLabel = Object.keys(sizesSet).sort().map(function (s) { return s + '"'; }).join(', ');
          cards.push(
            '<a class="fdp-product-card fdp-product-card--818" href="/products/fartilo-818-wiper-blade">' +
              '<div class="fdp-product-card__body">' +
                '<span class="fdp-product-card__badge">818 Series</span>' +
                '<p class="fdp-product-card__title">Fartilo 818 Conventional Wiper Blade</p>' +
                '<p class="fdp-product-card__sub">Sizes: ' + sizesLabel + '</p>' +
              '</div>' +
              '<span class="fdp-product-card__cta">View &amp; Order &rarr;</span>' +
            '</a>'
          );
        }
        /* else: no fits match this year — 818 card legitimately absent */
      }
    }

    var html = '';
    if (cards.length) {
      html = (
        '<div class="fdp-product-cards">' +
          '<p class="fdp-product-cards__heading">Compatible Fartilo Products</p>' +
          '<div class="fdp-product-cards__row">' +
            cards.join('') +
          '</div>' +
        '</div>'
      );
    }

    return { html: html, has799Card: has799Card, has818Card: has818Card };
  }

  /* ---- product card styles (injected once) ---- */

  function injectProductCardStyles() {
    if (document.getElementById('fdp-product-card-styles')) return;
    var style = document.createElement('style');
    style.id = 'fdp-product-card-styles';
    style.textContent = [
      '.fdp-product-cards{margin-top:1.25rem}',
      '.fdp-product-cards__heading{font-size:.75rem;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#6b7280;margin:0 0 .625rem}',
      '.fdp-product-cards__row{display:flex;gap:.75rem;flex-wrap:wrap}',
      '.fdp-product-card{display:flex;flex-direction:column;justify-content:space-between;flex:1 1 220px;min-width:200px;max-width:340px;border-radius:.625rem;padding:1rem 1.125rem;text-decoration:none;color:inherit;border:1.5px solid #1e3a5f;background:#fff;transition:box-shadow .18s,transform .18s;box-shadow:0 1px 4px rgba(10,22,40,.07)}',
      '.fdp-product-card:hover{box-shadow:0 4px 16px rgba(37,99,235,.18);transform:translateY(-2px)}',
      '.fdp-product-card__badge{display:inline-block;font-size:.65rem;font-weight:700;letter-spacing:.06em;text-transform:uppercase;border-radius:999px;padding:.15em .65em;margin-bottom:.5rem;color:#fff;background:#0a1628}',
      '.fdp-product-card--818 .fdp-product-card__badge{background:#2563eb}',
      '.fdp-product-card__title{font-size:.875rem;font-weight:700;color:#0a1628;margin:.1rem 0 .3rem;line-height:1.35}',
      '.fdp-product-card__sub{font-size:.78rem;color:#374151;margin:0}',
      '.fdp-product-card__cta{display:inline-block;margin-top:.875rem;font-size:.8rem;font-weight:700;color:#2563eb;white-space:nowrap}',
      '@media(max-width:480px){.fdp-product-cards__row{flex-direction:column}.fdp-product-card{max-width:100%}}'
    ].join('');
    document.head.appendChild(style);
  }

  /* ---- no-match fallback zone helpers ---- */

  /**
   * Show or hide the #fdp-no-match fallback zone.
   * When showing, populate the hidden vehicle field and update subject.
   * @param {boolean} show
   * @param {string} brand
   * @param {string} model
   * @param {number} year
   */
  function toggleNoMatch(show, brand, model, year) {
    var zone = document.getElementById('fdp-no-match');
    if (!zone) return;
    if (!show) {
      zone.hidden = true;
      return;
    }
    /* Populate hidden fields before revealing */
    var vehicleLabel = brand + ' ' + model + ' ' + year;
    var vehicleField = zone.querySelector('[data-fdp-nm-vehicle]');
    var subjectField = zone.querySelector('[data-fdp-nm-subject]');
    if (vehicleField) vehicleField.value = vehicleLabel;
    if (subjectField) subjectField.value = 'Fitment Check Request \u2013 ' + vehicleLabel;
    zone.hidden = false;
  }

  /* ---- quota UI helpers ---- */

  function updateQuotaBar(root, limit, period, used) {
    var bar = root.querySelector('[data-fdp-quota-text]');
    if (!bar) return;
    if (limit === -1) {
      bar.textContent = 'Unlimited lookups — active dealer account.';
      return;
    }
    var remaining = Math.max(0, limit - used);
    var periodLabel = period === 'daily' ? 'today' : 'this week';
    bar.textContent = remaining + ' lookup' + (remaining !== 1 ? 's' : '') + ' remaining ' + periodLabel + ' (of ' + limit + ').';
  }

  function showUpgrade(root, period) {
    var upgradeEl = root.querySelector('[data-fdp-upgrade]');
    var msgEl = root.querySelector('[data-fdp-upgrade-msg]');
    if (!upgradeEl) return;
    if (msgEl) {
      msgEl.textContent = period === 'daily'
        ? "You've used your daily allowance. Create an account for a higher weekly limit, or place a first order to unlock unlimited lookups."
        : "You've used your weekly allowance. Place a first order to unlock unlimited lookups, or come back next week.";
    }
    upgradeEl.hidden = false;
    var form = root.querySelector('[data-fdp-form]');
    if (form) form.hidden = true;
    var resultEl = root.querySelector('[data-fdp-result]');
    if (resultEl) resultEl.hidden = true;
    var quotaBar = root.querySelector('[data-fdp-quota-bar]');
    if (quotaBar) {
      var txt = quotaBar.querySelector('[data-fdp-quota-text]');
      if (txt) txt.textContent = 'Lookup limit reached.';
    }
  }

  /* ---- main init per lookup root ---- */

  function init(root) {
    var dataUrl = root.getAttribute('data-source-url');
    if (!dataUrl) return;

    /* 818 data URL: prefer versioned attribute (data-source-url-818) set by Liquid asset_url.
       Fallback: derive from 799 URL directory (unversioned — CDN cache risk). */
    var dataUrl818 = root.getAttribute('data-source-url-818');
    if (!dataUrl818) {
      dataUrl818 = dataUrl.replace(/[^\/]+$/, '') + 'fartilo-wiper-fitment-818.json';
      console.warn('[fartilo-wiper-lookup] data-source-url-818 not found on lookup root — falling back to unversioned URL. CDN cache may serve stale 818 data.');
    }

    /* Read config from data-* on wrapper (single source of truth) */
    var wrapper = document.querySelector('[data-fdp-lookup-root]') || root;
    var limit = parseInt(wrapper.getAttribute('data-js-limit') || '3', 10);
    var period = wrapper.getAttribute('data-js-period') || 'daily';

    var brandSelect = root.querySelector('[data-fdp-brand]');
    var modelSelect = root.querySelector('[data-fdp-model]');
    var yearInput = root.querySelector('[data-fdp-year]');
    var form = root.querySelector('[data-fdp-form]');
    var statusEl = root.querySelector('[data-fdp-status]');
    var resultBox = root.querySelector('[data-fdp-result]');
    var items = [];
    var byBrand = {};

    /* 818 data store: byBrand818[normBrand][normModel] = item */
    var items818 = [];
    var byBrand818 = {};

    function setStatus(msg) {
      if (statusEl) statusEl.textContent = msg || '';
    }

    function populateBrands() {
      var brands = Object.keys(byBrand).sort();
      brandSelect.innerHTML = '<option value="" disabled selected>Select brand\u2026</option>';
      brands.forEach(function (b) {
        var opt = document.createElement('option');
        opt.value = b;
        opt.textContent = b;
        brandSelect.appendChild(opt);
      });
      brandSelect.disabled = false;
    }

    function populateModels(brand) {
      var models = Object.keys(byBrand[brand] || {}).sort();
      modelSelect.innerHTML = '<option value="" disabled selected>Select model\u2026</option>';
      models.forEach(function (m) {
        var opt = document.createElement('option');
        opt.value = m;
        opt.textContent = m;
        modelSelect.appendChild(opt);
      });
      modelSelect.disabled = models.length === 0;
    }

    brandSelect.addEventListener('change', function () {
      populateModels(brandSelect.value);
      if (resultBox) resultBox.hidden = true;
      /* Also hide fallback zone on brand change */
      toggleNoMatch(false, '', '', 0);
    });

    /* Check initial quota state */
    var used = getUsed(period);
    updateQuotaBar(root, limit, period, used);

    if (limit !== -1 && used >= limit) {
      showUpgrade(root, period);
      /* Still load data so selects are ready if limit resets */
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      /* Re-check quota on every submit attempt */
      var currentUsed = getUsed(period);
      if (limit !== -1 && currentUsed >= limit) {
        showUpgrade(root, period);
        return;
      }

      var brand = brandSelect.value;
      var model = modelSelect.value;
      var year = parseInt(yearInput.value, 10);

      if (!brand || !model || !year) {
        setStatus('Please select brand, model and year.');
        return;
      }
      setStatus('');

      /* ---- 799 fitment lookup (original logic) ---- */
      var candidates = (byBrand[brand] && byBrand[brand][model]) || [];
      var ym = year * 100 + 6;
      var exact = candidates.filter(function (item) {
        var lower = item.y0 || 0;
        var upper = item.y1 || 999912;
        return ym >= lower - 12 && ym <= upper + 12;
      });

      var item799 = exact.length ? exact[0] : null;
      var html = exact.length
        ? buildResultHtml(exact[0], year)
        : buildClosestHtml(candidates, year);

      /* ---- 818 fitment lookup ---- */
      var nb = normBrand(brand);
      var nm = normModel(model);
      var item818 = null;
      if (byBrand818[nb] && byBrand818[nb][nm]) {
        item818 = byBrand818[nb][nm];
      }

      /* ---- append product cards below spec result (pass year for strict 818 filtering) ---- */
      var cardsResult = buildProductCardsResult(item799, item818, year);
      if (cardsResult.html) html += cardsResult.html;

      if (resultBox) {
        resultBox.innerHTML = html;
        resultBox.hidden = false;
      }

      /* ---- no-match fallback zone: show only when BOTH cards absent ---- */
      var anyCardShown = cardsResult.has799Card || cardsResult.has818Card;
      toggleNoMatch(!anyCardShown, brand, model, year);

      /* Increment counter and update bar */
      var newUsed = incrementUsed(period);
      updateQuotaBar(root, limit, period, newUsed);

      /* Save history for lead+ (all tiers — gating is Liquid-side) */
      saveLastResult(brand, model, year, html);

      /* Show upgrade when just exhausted */
      if (limit !== -1 && newUsed >= limit) {
        setTimeout(function () { showUpgrade(root, period); }, 1200);
      }
    });

    /* ---- load 799 data ---- */
    setStatus('Loading vehicle data\u2026');
    var p799 = fetch(dataUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        items = data.items || [];
        items.forEach(function (item) {
          if (!byBrand[item.b]) byBrand[item.b] = {};
          if (!byBrand[item.b][item.m]) byBrand[item.b][item.m] = [];
          byBrand[item.b][item.m].push(item);
        });
      });

    /* ---- load 818 data (parallel, non-blocking for selects) ---- */
    var p818 = fetch(dataUrl818)
      .then(function (r) { return r.json(); })
      .then(function (data818) {
        items818 = data818.items || [];
        /* Defensive: check first item has fits structure before indexing */
        if (items818.length > 0 && !Array.isArray(items818[0].fits)) {
          console.warn('[fartilo-wiper-lookup] 818 data loaded but missing fits structure — possible CDN cache serving old data. 818 cards will not render. URL:', dataUrl818);
          items818 = []; /* discard stale data entirely */
          return;
        }
        items818.forEach(function (item) {
          var nb = item.b; /* already normalized in data file */
          var nm = item.m; /* already normalized in data file */
          if (!byBrand818[nb]) byBrand818[nb] = {};
          /* keep first match per brand+model (year filtering happens at lookup time) */
          if (!byBrand818[nb][nm]) byBrand818[nb][nm] = item;
        });
      });

    Promise.all([p799, p818])
      .then(function () {
        populateBrands();
        setStatus('');
      })
      .catch(function () {
        /* Try partial recovery: if 799 loaded, still show selects */
        if (Object.keys(byBrand).length) {
          populateBrands();
          setStatus('');
        } else {
          setStatus('Could not load vehicle data. Please refresh or contact us.');
        }
      });
  }

  function initAll() {
    injectProductCardStyles();
    document.querySelectorAll('[data-fdp-lookup]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
